interface SVGIconProps {
  color?: string;
}
export const TTMIcon = ({ color = "black" }: SVGIconProps) => (
  <svg
    viewBox="0 0 19 10"
    height="100%"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.3252 9.16602C4.88574 9.16602 5.41211 9.05892 5.9043 8.84473C6.40104 8.63053 6.83626 8.33659 7.20996 7.96289C7.58822 7.58464 7.88444 7.14941 8.09863 6.65723C8.31283 6.16048 8.41992 5.62956 8.41992 5.06445C8.41992 4.49935 8.31283 3.9707 8.09863 3.47852C7.88444 2.98633 7.58822 2.55111 7.20996 2.17285C6.83626 1.7946 6.40104 1.49837 5.9043 1.28418C5.41211 1.06999 4.88574 0.962891 4.3252 0.962891C3.75553 0.962891 3.22233 1.06999 2.72559 1.28418C2.2334 1.49837 1.79818 1.7946 1.41992 2.17285C1.04622 2.55111 0.752279 2.98633 0.538086 3.47852C0.328451 3.9707 0.223633 4.49935 0.223633 5.06445C0.223633 5.62956 0.328451 6.16048 0.538086 6.65723C0.752279 7.14941 1.04622 7.58464 1.41992 7.96289C1.79818 8.33659 2.2334 8.63053 2.72559 8.84473C3.22233 9.05892 3.75553 9.16602 4.3252 9.16602ZM14.5518 9.16602C15.1123 9.16602 15.6387 9.05892 16.1309 8.84473C16.6276 8.63053 17.0651 8.33659 17.4434 7.96289C17.8216 7.58464 18.1156 7.14941 18.3252 6.65723C18.5394 6.16048 18.6465 5.62956 18.6465 5.06445C18.6465 4.49935 18.5394 3.9707 18.3252 3.47852C18.1156 2.98633 17.8216 2.55111 17.4434 2.17285C17.0651 1.7946 16.6276 1.49837 16.1309 1.28418C15.6387 1.06999 15.1123 0.962891 14.5518 0.962891C13.9821 0.962891 13.4489 1.06999 12.9521 1.28418C12.46 1.49837 12.0247 1.7946 11.6465 2.17285C11.2728 2.55111 10.9788 2.98633 10.7646 3.47852C10.555 3.9707 10.4502 4.49935 10.4502 5.06445C10.4502 5.62956 10.555 6.16048 10.7646 6.65723C10.9788 7.14941 11.2728 7.58464 11.6465 7.96289C12.0202 8.33659 12.4554 8.63053 12.9521 8.84473C13.4489 9.05892 13.9821 9.16602 14.5518 9.16602ZM14.5518 7.84668C14.0368 7.84668 13.5674 7.72363 13.1436 7.47754C12.7243 7.22689 12.3893 6.88965 12.1387 6.46582C11.888 6.04199 11.7627 5.57487 11.7627 5.06445C11.7627 4.55404 11.888 4.08919 12.1387 3.66992C12.3893 3.24609 12.7243 2.90885 13.1436 2.6582C13.5674 2.40755 14.0368 2.28223 14.5518 2.28223C15.0576 2.28223 15.5202 2.40983 15.9395 2.66504C16.3633 2.91569 16.7005 3.25293 16.9512 3.67676C17.2018 4.09603 17.3271 4.55859 17.3271 5.06445C17.3271 5.57031 17.2018 6.03516 16.9512 6.45898C16.7005 6.88281 16.3633 7.22005 15.9395 7.4707C15.5202 7.72135 15.0576 7.84668 14.5518 7.84668Z"
      fill={
        color
          ? color === "bluegradient"
            ? "url(#paint0_linear_586_2224)"
            : color === "purplegradient"
            ? "url(#paint0_linear_586_2224)"
            : color
          : "black"
      }
    />
    <defs>
      {color === "purplegradient" && (
        <linearGradient
          id="paint0_linear_586_2224"
          x1="0.2"
          y1="-4"
          x2="26.6022"
          y2="2.83473"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C72A8E" />
          <stop offset="1" stopColor="#7815DA" />
        </linearGradient>
      )}
      {color === "bluegradient" && (
        <linearGradient
          id="paint0_linear_586_2224"
          x1="-7.89109"
          y1="-5"
          x2="26.1628"
          y2="0.975647"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8E8EF2" />
          <stop offset="1" stopColor="#6911E7" />
        </linearGradient>
      )}
    </defs>
  </svg>
);
